var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71543 5.73261H8.50093V7.12011C8.90218 6.32211 9.93118 5.60511 11.4769 5.60511C14.4402 5.60511 15.1437 7.19361 15.1437 10.1081V15.5059H12.1437V10.7719C12.1437 9.11211 11.7424 8.17611 10.7209 8.17611C9.30418 8.17611 8.71543 9.18486 8.71543 10.7711V15.5059H5.71543V5.73261ZM0.571177 15.3784H3.57118V5.60511H0.571177V15.3784ZM4.00093 2.41836C4.00104 2.66982 3.95117 2.91879 3.85422 3.1508C3.75727 3.38281 3.61517 3.59324 3.43618 3.76986C3.07348 4.13033 2.58253 4.3321 2.07118 4.33086C1.56072 4.33052 1.07091 4.12926 0.707677 3.77061C0.529335 3.59339 0.387716 3.38273 0.290935 3.15068C0.194153 2.91864 0.144111 2.66978 0.143677 2.41836C0.143677 1.91061 0.346177 1.42461 0.708427 1.06611C1.07134 0.706978 1.56136 0.505635 2.07193 0.50586C2.58343 0.50586 3.07393 0.70761 3.43618 1.06611C3.79768 1.42461 4.00093 1.91061 4.00093 2.41836Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.02ce6db1b2efa2823e78004c91325f65.svg";
export { ForwardRef as ReactComponent };